import { useEffect, useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import { Grid } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import ManualAyuda from "../../controls/ManualAyuda";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { postData, pathData, deleteData } from "../../Utils/Http/api";
import { fetchSujetoContactoTipos } from "../../Utils/SujetoContactoTipo";
import CircularProgress from '@mui/material/CircularProgress';
import { Link, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { PencilSquare, BuildingFillAdd } from "react-bootstrap-icons";

const tiposResponsabilidad = [
    { id: 1, label: 'Responsable Legal' },
    { id: 2, label: 'Responsable Operativo' },
    { id: 3, label: 'Responsable Sistemas' },
];

function OrganismoList() {
    const formatDate = (d) => {
        if (!d) return '-';
        const dt = new Date(d);
        if (isNaN(dt)) return d;
        const day = String(dt.getDate()).padStart(2, '0');
        const month = String(dt.getMonth() + 1).padStart(2, '0');
        const year = dt.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [filterCuit, setFilterCuit] = useState('');
    const [filterDenominacion, setFilterDenominacion] = useState('');
    const [openAddResp, setOpenAddResp] = useState(false);
    const [openEditResp, setOpenEditResp] = useState(false);
    const [respEdit, setRespEdit] = useState(null);
    const [respNombre, setRespNombre] = useState("");
    const [respTipo, setRespTipo] = useState(null);
    const [respTipoContacto, setRespTipoContacto] = useState("");
    const [tiposContactoOptions, setTiposContactoOptions] = useState([]);
    const [respSelectedTipoContacto, setRespSelectedTipoContacto] = useState(null);
    const [respContacto, setRespContacto] = useState("");
    const [currentOrganismoId, setCurrentOrganismoId] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });

    const fetchData = useCallback(async (filters = {}) => {
        setLoading(true);
        try {
            const body = filters || {};
            const res = await postData('/OrganismoListar', body);
            const list = res?.value || [];
            const data = list.map(item => {
                const denominacion = (
                    <MDBox>
                        <MDTypography variant="h6" color="text" fontWeight="medium">{item.denominacion}</MDTypography>
                        <MDTypography variant="caption" color="success" fontWeight="medium">CUIT: {item.cuit}</MDTypography>


                        <MDBox mt={1}>
                            {Array.isArray(item.responsables) && item.responsables.length > 0 ? (
                                item.responsables.map(r => (
                                    <MDBox key={r.idOrganismoResponsable} display="flex" alignItems="center" gap={1} mb={0.5}>
                                        <MDTypography variant="caption" color="text" fontWeight="medium">
                                            {(tiposResponsabilidad.find(t => t.id === r.tipoResponsabilidad) || {}).label || 'N/A'} {r.nombreApellido} ({((tiposContactoOptions.find(t => t.id === r.idSujetoContactoTipo) || {}).label) || r.tipoContacto})
                                        </MDTypography>

                                        <MDTypography variant="caption" color="text" sx={{ ml: 1 }}>{r.contacto}</MDTypography>
                                        <MDBox>
                                            <IconButton size="small" onClick={() => handleOpenEditResp(r, item.idOrganismo)} sx={{ padding: '3px' }} aria-label="editar responsable"><EditIcon color="info" /></IconButton>
                                            <IconButton size="small" onClick={() => handleDeleteResp(r.idOrganismoResponsable)} sx={{ padding: '3px' }} aria-label="eliminar responsable"><DeleteIcon color="error" /></IconButton>
                                        </MDBox>
                                    </MDBox>
                                ))
                            ) : (
                                <MDTypography variant="caption" color="text">Sin responsables</MDTypography>
                            )}
                        </MDBox>
                        <MDBox mt={1}>
                            <IconButton size="small" onClick={() => handleOpenAddResp(item.idOrganismo)} aria-label="agregar responsable" sx={{ padding: '6px', borderRadius: 1, border: '1px solid', borderColor: 'rgba(0,0,0,0.08)' }}><PersonAddIcon fontSize="small" /></IconButton>
                        </MDBox>
                    </MDBox>
                );

                const domicilioMail = (
                    <MDBox>
                        <MDTypography variant="caption" color="text">Domicilio: {item.domicilio || 'N/A'}</MDTypography>
                        <MDBox mt={0.5}>
                            <MDTypography variant="caption" color="text">Mail: {item.mailInstitucional || 'N/A'}</MDTypography>
                        </MDBox>
                    </MDBox>
                );

                const periodo = (
                    <MDBox>
                        <MDTypography variant="caption" color="text">Desde: {formatDate(item.fechaContratoDesde)}</MDTypography>
                        <MDBox mt={0.5}>
                            <MDTypography variant="caption" color="text">Hasta: {formatDate(item.fechaContratoHasta)}</MDTypography>
                        </MDBox>
                    </MDBox>
                );

                const responsables = (
                    <MDBox>
                        {Array.isArray(item.responsables) && item.responsables.length > 0 ? (
                            item.responsables.map(r => (
                                <MDBox key={r.idOrganismoResponsable} display="flex" alignItems="center" gap={1} mb={0.5}>
                                    <MDTypography variant="caption" color="text" fontWeight="medium">
                                        {(tiposResponsabilidad.find(t => t.id === r.tipoResponsabilidad) || {}).label || 'N/A'} {r.nombreApellido} ({((tiposContactoOptions.find(t => t.id === r.idSujetoContactoTipo) || {}).label) || r.tipoContacto})
                                    </MDTypography>
                                    <MDTypography variant="caption" color="text" sx={{ ml: 1 }}>{r.contacto}</MDTypography>
                                    <MDBox>
                                        <IconButton size="small" onClick={() => handleOpenEditResp(r, item.idOrganismo)} sx={{ padding: '3px' }} aria-label="editar responsable"><EditIcon color="info" /></IconButton>
                                        <IconButton size="small" onClick={() => handleDeleteResp(r.idOrganismoResponsable)} sx={{ padding: '3px' }} aria-label="eliminar responsable"><DeleteIcon color="error" /></IconButton>
                                    </MDBox>
                                </MDBox>
                            ))
                        ) : (
                            <MDTypography variant="caption" color="text">Sin responsables</MDTypography>
                        )}
                        <MDBox mt={1}>
                            <IconButton size="small" onClick={() => handleOpenAddResp(item.idOrganismo)} aria-label="agregar responsable" sx={{ padding: '6px', borderRadius: 1, border: '1px solid', borderColor: 'rgba(0,0,0,0.08)' }}><PersonAddIcon fontSize="small" /></IconButton>
                        </MDBox>
                    </MDBox>
                );

                const action = (
                    // <MDBox display="flex" alignItems="center" justifyContent="center">
                    //     <Link to={`../OrganismoEdit/${item.idOrganismo}`}>
                    //         <MDButton variant="text" color="dark">Editar</MDButton>
                    //     </Link>
                    // </MDBox>
                    <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
                        <MDBox>
                            <Link to={`../OrganismoEdit/${item.idOrganismo}`}>
                                <MDButton variant="text" color="dark" size="large">
                                    <PencilSquare color="blue" />
                                </MDButton>
                            </Link>
                        </MDBox>
                    </MDBox>
                );

                return { detalle: denominacion, domicilioMail, periodo, action };
            });
            setRows(data);
            setColumns([
                { Header: 'Organismo y Responsables', accessor: 'detalle', align: 'left' },
               
                { Header: 'Domicilio / Mail', accessor: 'domicilioMail', align: 'left' },
                { Header: 'Período', accessor: 'periodo', align: 'left' },
                { Header: 'Acciones', accessor: 'action', align: 'center' }
            ]);
            setRefreshKey(k => k + 1);
            return list;
        } catch (ex) {
            console.error('Error cargando organismos', ex);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchData(); }, [fetchData]);

    const handleSearch = async () => {
        const body = {
            cuit: filterCuit ? filterCuit.trim() : null,
            denominacion: filterDenominacion ? filterDenominacion.trim() : null,
        };
        await fetchData(body);
    };

    const handleClear = async () => {
        setFilterCuit('');
        setFilterDenominacion('');
        await fetchData({});
    };

    const navigate = useNavigate();
    const handleAddOrganismo = () => navigate('/OrganismoAdd');

    // responsables handlers
    const handleOpenAddResp = (idOrganismo) => {
        setCurrentOrganismoId(idOrganismo);
        setRespNombre(''); setRespTipo(null); setRespTipoContacto(''); setRespContacto('');
        setRespSelectedTipoContacto(null);
        // load contacto tipos
        (async () => {
            try {
                const tipos = await fetchSujetoContactoTipos();
                const list = (tipos || []).map(t => ({ id: t.idSujetoContactoTipo, label: t.descripcion }));
                setTiposContactoOptions(list);
            } catch (ex) {
                console.error('Error cargando tipos de contacto', ex);
            }
        })();
        setOpenAddResp(true);
    };

    const handleCloseAddResp = () => { setOpenAddResp(false); setCurrentOrganismoId(null); };

    const handleSaveAddResp = async () => {
        try {
            const payload = { idOrganismo: currentOrganismoId, nombreApellido: respNombre, tipoResponsabilidad: respTipo?.id || null, idSujetoContactoTipo: respSelectedTipoContacto?.id || null, tipoContacto: respSelectedTipoContacto?.label || respTipoContacto, contacto: respContacto };
            const res = await postData('/OrganismoResponsableAlta', payload);
            if (res?.isSuccess) { setSnackbar({ open: true, msg: 'Responsable agregado', severity: 'success' }); setOpenAddResp(false); await fetchData(); }
            else setSnackbar({ open: true, msg: res?.error || 'Error agregando responsable', severity: 'error' });
        } catch (ex) { console.error('Error agregando responsable', ex); setSnackbar({ open: true, msg: 'Error agregando responsable', severity: 'error' }); }
    };

    const handleOpenEditResp = (r, idOrganismo) => {
        setRespEdit(r);
        setRespNombre(r.nombreApellido || '');
        setRespTipo(tiposResponsabilidad.find(t => t.id === r.tipoResponsabilidad) || null);
        setRespTipoContacto(r.tipoContacto || '');
        setRespSelectedTipoContacto(null);
        // load contacto tipos and preselect
        (async () => {
            try {
                const tipos = await fetchSujetoContactoTipos();
                const list = (tipos || []).map(t => ({ id: t.idSujetoContactoTipo, label: t.descripcion }));
                setTiposContactoOptions(list);
                const pre = list.find(x => x.id === r.idSujetoContactoTipo) || list.find(x => x.label === (r.tipoContacto || '')) || null;
                setRespSelectedTipoContacto(pre);
            } catch (ex) {
                console.error('Error cargando tipos de contacto', ex);
            }
        })();
        setRespContacto(r.contacto || '');
        setCurrentOrganismoId(idOrganismo);
        setOpenEditResp(true);
    };

    const handleCloseEditResp = () => { setOpenEditResp(false); setRespEdit(null); setCurrentOrganismoId(null); };

    const handleSaveEditResp = async () => {
        try {
            const payload = { idOrganismo: currentOrganismoId, idOrganismoResponsable: respEdit.idOrganismoResponsable, nombreApellido: respNombre, tipoResponsabilidad: respTipo?.id || null, idSujetoContactoTipo: respSelectedTipoContacto?.id || null, tipoContacto: respSelectedTipoContacto?.label || respTipoContacto, contacto: respContacto };
            const res = await pathData('/OrganismoResponsableUpdate', payload);
            if (res?.isSuccess) { setSnackbar({ open: true, msg: 'Responsable actualizado', severity: 'success' }); setOpenEditResp(false); await fetchData(); }
            else setSnackbar({ open: true, msg: res?.error || 'Error actualizando responsable', severity: 'error' });
        } catch (ex) { console.error('Error actualizando responsable', ex); setSnackbar({ open: true, msg: 'Error actualizando responsable', severity: 'error' }); }
    };

    const handleDeleteResp = async (id) => {
        try {
            const res = await deleteData(`/OrganismoResponsableDelete/${id}`);
            if (res?.isSuccess) { setSnackbar({ open: true, msg: 'Responsable eliminado', severity: 'success' }); await fetchData(); }
            else setSnackbar({ open: true, msg: res?.error || 'Error eliminando responsable', severity: 'error' });
        } catch (ex) { console.error('Error eliminando responsable', ex); setSnackbar({ open: true, msg: 'Error eliminando responsable', severity: 'error' }); }
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="secondary" borderRadius="lg" coloredShadow="light" display="flex" justifyContent="space-between" alignItems="center">
                                <MDTypography variant="h6" color="white">Organismos</MDTypography>
                                <ManualAyuda seccion="Organismos" />
                            </MDBox>
                            <MDBox pt={3} py={3} px={2}>
                                                                <MDBox display="flex" gap={2} alignItems="center" mb={2}>
                                                                        <TextField label="CUIT" value={filterCuit} onChange={(e) => setFilterCuit(e.target.value)} size="small" />
                                                                        <TextField label="Denominación" value={filterDenominacion} onChange={(e) => setFilterDenominacion(e.target.value)} size="small" sx={{ minWidth: 300 }} />
                                                                        <MDButton variant="gradient" color="info" onClick={handleSearch}>Buscar</MDButton>
                                                                        <MDButton variant="text" color="dark" onClick={handleClear}>Limpiar</MDButton>
                                                                </MDBox>

                                <MDButton
                                    onClick={handleAddOrganismo}
                                    variant="gradient"
                                    color="success"
                                    endIcon={<BuildingFillAdd />}
                                >
                                    Agregar
                                </MDButton>
                                {loading ? (
                                    <MDBox display="flex" justifyContent="center" alignItems="center" py={6}><CircularProgress /></MDBox>
                                ) : (
                                    <DataTable key={refreshKey} table={{ columns, rows }} isSorted={false} showTotalEntries canSearch={false} noEndBorder pagination={{ color: 'info', variant: 'gradient' }} />
                                )}

                                {/* Add responsable dialog */}
                                <Dialog open={openAddResp} onClose={handleCloseAddResp} fullWidth maxWidth="sm">
                                    <DialogTitle>Agregar responsable</DialogTitle>
                                    <DialogContent>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <TextField label="Nombre y Apellido" value={respNombre} onChange={(e) => setRespNombre(e.target.value)} fullWidth />
                                            <Autocomplete options={tiposResponsabilidad} getOptionLabel={(o) => o.label} value={respTipo} onChange={(e, nv) => setRespTipo(nv)} renderInput={(params) => <TextField {...params} label="Tipo responsabilidad" />} />
                                            <Autocomplete
                                                options={tiposContactoOptions}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={respSelectedTipoContacto}
                                                onChange={(e, newVal) => { setRespSelectedTipoContacto(newVal); setRespTipoContacto(newVal?.label || ''); }}
                                                renderInput={(params) => <TextField {...params} label="Tipo contacto" />}
                                            />
                                            <TextField label="Contacto" value={respContacto} onChange={(e) => setRespContacto(e.target.value)} fullWidth />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="text" color="dark" onClick={handleCloseAddResp}>Cancelar</MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleSaveAddResp}>Guardar</MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Edit responsable dialog */}
                                <Dialog open={openEditResp} onClose={handleCloseEditResp} fullWidth maxWidth="sm">
                                    <DialogTitle>Editar responsable</DialogTitle>
                                    <DialogContent>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <TextField label="Nombre y Apellido" value={respNombre} onChange={(e) => setRespNombre(e.target.value)} fullWidth />
                                            <Autocomplete options={tiposResponsabilidad} getOptionLabel={(o) => o.label} value={respTipo} onChange={(e, nv) => setRespTipo(nv)} renderInput={(params) => <TextField {...params} label="Tipo responsabilidad" />} />
                                            <Autocomplete
                                                options={tiposContactoOptions}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={respSelectedTipoContacto}
                                                onChange={(e, newVal) => { setRespSelectedTipoContacto(newVal); setRespTipoContacto(newVal?.label || ''); }}
                                                renderInput={(params) => <TextField {...params} label="Tipo contacto" />}
                                            />
                                            <TextField label="Contacto" value={respContacto} onChange={(e) => setRespContacto(e.target.value)} fullWidth />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="text" color="dark" onClick={handleCloseEditResp}>Cancelar</MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleSaveEditResp}>Guardar</MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                                    <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">{snackbar.msg}</MuiAlert>
                                </Snackbar>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default OrganismoList;
